import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./presentation/features/auth/auth.routes').then((m) => m.routes),
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'owner',
    loadChildren: () => import('./presentation/features/owner/owner.route').then((m) => m.routes),
  },
  {
    path: 'manager',
    loadChildren: () => import('./presentation/features/manager/manager.route').then((m) => m.routes),
  },
   {
    path: 'admin',
    loadChildren: () => import('./presentation/features/admin/admin.route').then((m) => m.routes),
  },
  {
    path: 'client',
    loadChildren: () => import('./presentation/features/clients/client.route').then((m) => m.routes),
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
